import { SecurityWrapper } from "./style";
import Text from "components/common/Text";
import Button from "components/common/Button";
import Translation from "libs/Translation";
import ModalManager from "libs/ModalManager";

const SecurityAlert: React.FC = () => {
  return (
    <SecurityWrapper>
      <img src="/nextasset/images/security.svg" alt="" />
      <Text tag="p" className="title">
        {Translation.t("text.security-warning")}
      </Text>
      <Text tag="p" className="desc">
        {Translation.t("text.wait-for-2-minutes")}
      </Text>
      <Button className="button" onClick={() => ModalManager.hide()}>
        {Translation.t("label.ok")}
      </Button>
    </SecurityWrapper>
  );
};
export default SecurityAlert;
